<template>
  <div>
    <form @submit.prevent="submit">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent 
            type="text"
            :name="'workflow'"
            v-model="formulario.workflow"
            :placeholder="'Nome do Workflow'"
            data-vv-as="Workflow"
            v-validate="'required|max:255'"
            :error="validationErrors.first('workflow')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent
            :name="'ctrl_tipo_aging_id'"
            :listaDeOptions="listaDeTiposAgings"
            v-model="formulario.ctrl_tipo_aging_id"
            :optionLabel="'tipo'"
            :placeholder="'Tipo de Aging'"
            :error="validationErrors.first('ctrl_tipo_aging_id')"
            data-vv-as="Tipo de Aging"
          />
        </div>

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent 
            type="number" 
            min="0"
            :name="'aging'"
            v-model="formulario.aging"
            :placeholder="'Aging'"
            data-vv-as="Aging"
            v-validate="'integer|min:0'"
            :error="validationErrors.first('aging')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent 
            type="number"
            min="0"
            :name="'ordem'"
            v-model="formulario.ordem"
            :placeholder="'Ordem de Exibição'"
            data-vv-as="Ordem"
            v-validate="'integer|min:0'"
            :error="validationErrors.first('ordem')"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal">Cancelar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "FormularioCtrlWorkflowComponent",
  props: {
    tipoFormulario: {
      type: String,
      default: 'salvar'
    },
    workflow: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      formulario: this.workflow ? { ...this.workflow } : {
        ctrl_workflow_id: '',
        workflow: '',
        ctrl_tipo_aging_id: '',
        aging: '',
        ordem: '',
        user_cadastro_id: '',
        user_suspensao_id: ''
      }
    }
  },
  
  created () {
    this.listarTipoAgings();
  },
  
  computed: {
    ...mapGetters('ctrlWorkflow', ['listaDeTiposAgings'])
  },
  methods: {
    ...mapActions('ctrlWorkflow', ['listarTipoAgings', 'salvarWorkflow','atualizarWorkflow']),

    limparCampos () {
      this.formulario.ctrl_workflow_id = '';
      this.formulario.workflow = '';
      this.formulario.ctrl_tipo_aging_id = '';
      this.formulario.aging = '';
      this.formulario.ordem = '';
      this.$validator.reset();
    },  

    async submit () {
      const valido = await this.$validator.validateAll();
      if (!valido) return;

      const acao = this.tipoFormulario === 'salvar'
        ? this.salvarWorkflow
        : this.atualizarWorkflow;

      const resp = await acao(this.formulario);
      if (!resp) return;

      this.limparCampos();
      this.fecharModal();
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>
